import React, { useContext, useState } from "react";
import {
  Sidebar,
  SubMenu,
  Menu,
  MenuItem,
  useProSidebar,
} from "react-pro-sidebar";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import InventoryIcon from "@mui/icons-material/Inventory";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import StorageIcon from "@mui/icons-material/Storage";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import BadgeIcon from "@mui/icons-material/Badge";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ListIcon from "@mui/icons-material/List";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PersonIcon from "@mui/icons-material/Person";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import { AppRegistrationOutlined } from "@mui/icons-material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "./SideBar.css";
import { loginContext } from "../../App";
import Groups3Icon from "@mui/icons-material/Groups3";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import PollIcon from "@mui/icons-material/Poll";
import AddchartIcon from "@mui/icons-material/Addchart";
import FactoryIcon from "@mui/icons-material/Factory";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ForkRightIcon from "@mui/icons-material/ForkRight";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import CoffeeMakerIcon from "@mui/icons-material/CoffeeMaker";
import StorefrontIcon from "@mui/icons-material/Storefront";
import GradingIcon from "@mui/icons-material/Grading";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import GridViewIcon from "@mui/icons-material/GridView";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BackupTableOutlinedIcon from "@mui/icons-material/BackupTableOutlined";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import ListAltIcon from "@mui/icons-material/ListAlt";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import { PlusSquareFilled, RetweetOutlined } from "@ant-design/icons";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
import DeleteSweepRoundedIcon from "@mui/icons-material/DeleteSweepRounded";
import BusinessIcon from "@mui/icons-material/Business";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import DocumentScannerOutlinedIcon from "@mui/icons-material/DocumentScannerOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import CategoryIcon from "@mui/icons-material/Category";

export default function SideBar() {
  const { collapseSidebar } = useProSidebar();
  const [IS_SIDEBAR_OPEN, SET_IS_SIDEBAR_OPEN] = useState(true);
  const { userPermissions, setuserPermissions } = useContext(loginContext);

  const [activePage, setActivePage] = useState(null);

  function handleActive(event) {
    if (activePage) activePage.classList.remove("active");
    event.target.classList.add("active");
    setActivePage(event.target);
  }
  const webmailUrl = "http://webmail.agrigate.asia/";
  const oneThreadUrl = "https://onethread.agrigate.network/";

  return (
    <>
      <div style={{ display: "flex", height: "100%", zIndex: 900 }}>
        <Sidebar>
          <h5
            className="text-center mt-4"
            style={{
              color: "#46604A",
            }}
          >
            {IS_SIDEBAR_OPEN ? "MIS Dashboard" : null}
            <MenuIcon
              onClick={() => {
                collapseSidebar();
                SET_IS_SIDEBAR_OPEN(!IS_SIDEBAR_OPEN);
              }}
              style={{ fontSize: "28", cursor: "pointer" }}
            />
          </h5>
          <Menu>
            {userPermissions?.includes("view_home_menu") && (
              <MenuItem
                className="NavigationLink"
                icon={<DashboardIcon style={{ color: "inherit" }} />}
                style={{ fontSize: "15px" }}
                onClick={handleActive}
                component={<Link className="NavigationLink" to="/home" />}
              >
                {IS_SIDEBAR_OPEN ? "Home" : null}
              </MenuItem>
            )}
            {userPermissions?.includes("view_webmail_menu") && (
              <MenuItem
                className="NavigationLink"
                style={{ fontSize: "15px" }}
                icon={<LocalPostOfficeIcon style={{ color: "inherit" }} />}
                component={
                  <a
                    className="NavigationLink"
                    href={webmailUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleActive}
                  >
                    {IS_SIDEBAR_OPEN ? "WebMail" : null}
                  </a>
                }
              >
                {IS_SIDEBAR_OPEN ? "WebMail" : null}
              </MenuItem>
            )}
            {userPermissions?.includes("view_budget_menu") && (
              <SubMenu
                className="NavigationLink"
                style={{ fontSize: "15px" }}
                icon={<AccountBalanceIcon style={{ color: "inherit" }} />}
                label={IS_SIDEBAR_OPEN ? "Budget" : null}
              >
                {userPermissions?.includes("view_requisition_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<RequestQuoteIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/requisition"
                        onClick={handleActive}
                      />
                    }
                  >
                    Requisition
                  </MenuItem>
                )}
                {userPermissions?.includes("view_withdrawal_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<CreditScoreIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/withdrawal"
                        onClick={handleActive}
                      />
                    }
                  >
                    Withdrawal
                  </MenuItem>
                )}
                <SubMenu
                  className="NavigationLink"
                  style={{ fontSize: "15px" }}
                  icon={<FactCheckIcon style={{ color: "inherit" }} />}
                  label={IS_SIDEBAR_OPEN ? "Expense" : null}
                >
                  {userPermissions?.includes("view_expense_menu") && (
                    <MenuItem
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      icon={
                        <CategoryIcon
                          style={{ color: "inherit", fontSize: "22px" }}
                        />
                      }
                      component={
                        <Link
                          className="NavigationLink"
                          to="/category"
                          onClick={handleActive}
                        />
                      }
                    >
                      Category
                    </MenuItem>
                  )}

                  {userPermissions?.includes("view_expense_menu") && (
                    <MenuItem
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      icon={
                        <PlusSquareFilled
                          style={{ color: "inherit", fontSize: "22px" }}
                        />
                      }
                      component={
                        <Link
                          className="NavigationLink"
                          to="/expense"
                          onClick={handleActive}
                        />
                      }
                    >
                      Create
                    </MenuItem>
                  )}
                </SubMenu>
              </SubMenu>
            )}
            {userPermissions?.includes("view_operations_menu") && (
              <SubMenu
                className="NavigationLink "
                style={{ fontSize: "15px" }}
                icon={<Groups3Icon style={{ color: "inherit" }} />}
                label={IS_SIDEBAR_OPEN ? "Operations" : null}
              >
                {userPermissions?.includes("view_operations_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<GridViewIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/operationsDashboard"
                        onClick={handleActive}
                      />
                    }
                  >
                    Dashboard
                  </MenuItem>
                )}
                {userPermissions?.includes("view_po_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<FilterFramesIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/poList"
                        onClick={handleActive}
                      />
                    }
                  >
                    Purchase Order
                  </MenuItem>
                )}
                {userPermissions?.includes("view_consultation_menu") && (
                  <SubMenu
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={
                      <AnalyticsOutlinedIcon style={{ color: "inherit" }} />
                    }
                    label="Consultation"
                  >
                    {userPermissions?.includes("view_consultation_menu") && (
                      <MenuItem
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        icon={
                          <AnalyticsOutlinedIcon style={{ color: "inherit" }} />
                        }
                        component={
                          <Link
                            className="NavigationLink"
                            to="/consultationDashboard"
                            onClick={handleActive}
                          />
                        }
                      >
                        Admin
                      </MenuItem>
                    )}
                    {userPermissions?.includes("view_consultant_menu") && (
                      <MenuItem
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        icon={
                          <AppRegistrationOutlined
                            style={{ color: "inherit" }}
                          />
                        }
                        component={
                          <Link
                            className="NavigationLink"
                            to="/consultant"
                            onClick={handleActive}
                          />
                        }
                      >
                        Consultant
                      </MenuItem>
                    )}
                  </SubMenu>
                )}
                <SubMenu
                  className="NavigationLink"
                  style={{ fontSize: "15px" }}
                  icon={<HistoryEduIcon style={{ color: "inherit" }} />}
                  label={"Contract Farming"}
                >
                  {userPermissions?.includes("view_contract_farming_menu") && (
                    <MenuItem
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      icon={<HistoryEduIcon style={{ color: "inherit" }} />}
                      component={
                        <Link
                          className="NavigationLink"
                          to="/contractFarming"
                          onClick={handleActive}
                        />
                      }
                    >
                      Dashboard
                    </MenuItem>
                  )}
                  {userPermissions?.includes("view_contract_farming_reg") && (
                    <MenuItem
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      icon={
                        <AppRegistrationOutlined style={{ color: "inherit" }} />
                      }
                      component={
                        <Link
                          className="NavigationLink"
                          to="/contractFarmingReg"
                          onClick={handleActive}
                        />
                      }
                    >
                      Registration
                    </MenuItem>
                  )}
                  {userPermissions?.includes("view_contract_farming_menu") && (
                    <MenuItem
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      icon={<CheckBoxIcon style={{ color: "inherit" }} />}
                      component={
                        <Link
                          className="NavigationLink"
                          to="/productDemand"
                          onClick={handleActive}
                        />
                      }
                    >
                      Product Demand
                    </MenuItem>
                  )}
                  {userPermissions?.includes("view_contract_farming_menu") && (
                    <MenuItem
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      icon={<AccessTimeIcon style={{ color: "inherit" }} />}
                      component={
                        <Link
                          className="NavigationLink"
                          to="/contractFarmingHistory"
                          onClick={handleActive}
                        />
                      }
                    >
                      History
                    </MenuItem>
                  )}
                </SubMenu>
                {userPermissions?.includes("view_survey_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<PollIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/survey"
                        onClick={handleActive}
                      />
                    }
                  >
                    Survey
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {userPermissions?.includes("view_inventory_menu") && (
              <SubMenu
                className="NavigationLink "
                style={{ fontSize: "15px" }}
                icon={<InventoryIcon style={{ color: "inherit" }} />}
                label={IS_SIDEBAR_OPEN ? "Inventory" : null}
              >
                {userPermissions?.includes("view_purchase_menu") && (
                  <SubMenu
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<LocalMallIcon style={{ color: "inherit" }} />}
                    label="Purchase"
                  >
                    {userPermissions?.includes(
                      "view_purchase_product_menu",
                    ) && (
                      <MenuItem
                        icon={
                          <ShoppingCartCheckoutIcon
                            style={{ color: "inherit" }}
                          />
                        }
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        component={
                          <Link
                            className="NavigationLink"
                            to="/productReceive"
                            onClick={handleActive}
                          />
                        }
                      >
                        Product Receive
                      </MenuItem>
                    )}
                    {userPermissions?.includes("view_purchase_menu") && (
                      <MenuItem
                        icon={<ReceiptIcon style={{ color: "inherit" }} />}
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        component={
                          <Link
                            className="NavigationLink"
                            to="/managePurchase"
                            onClick={handleActive}
                          />
                        }
                      >
                        Manage
                      </MenuItem>
                    )}
                    {userPermissions?.includes("view_supplier_menu") && (
                      <MenuItem
                        icon={
                          <DeliveryDiningIcon style={{ color: "inherit" }} />
                        }
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        component={
                          <Link
                            className="NavigationLink"
                            to="/supplier"
                            onClick={handleActive}
                          />
                        }
                      >
                        Supplier
                      </MenuItem>
                    )}
                    {userPermissions?.includes("view_brand_menu") && (
                      <MenuItem
                        icon={<BusinessIcon style={{ color: "inherit" }} />}
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        component={
                          <Link
                            className="NavigationLink"
                            to="/brand"
                            onClick={handleActive}
                          />
                        }
                      >
                        Brand
                      </MenuItem>
                    )}
                  </SubMenu>
                )}
                <SubMenu
                  className="NavigationLink"
                  style={{ fontSize: "15px" }}
                  icon={<PointOfSaleIcon style={{ color: "inherit" }} />}
                  label="Point of Sale"
                >
                  {userPermissions?.includes("view_gui_menu") && (
                    <MenuItem
                      icon={<ReceiptLongIcon style={{ color: "inherit" }} />}
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      component={
                        <Link
                          className="NavigationLink"
                          to="/gui"
                          onClick={handleActive}
                        />
                      }
                    >
                      Quick Invoice
                    </MenuItem>
                  )}
                  {userPermissions?.includes("view_manage_sales_menu") && (
                    <MenuItem
                      icon={<ReceiptIcon style={{ color: "inherit" }} />}
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      component={
                        <Link
                          className="NavigationLink"
                          to="/manageSales"
                          onClick={handleActive}
                        />
                      }
                    >
                      Manage Sales
                    </MenuItem>
                  )}
                  {userPermissions?.includes("view_pos_menu") && (
                    <MenuItem
                      icon={
                        <BackupTableOutlinedIcon style={{ color: "inherit" }} />
                      }
                      className="NavigationLink"
                      style={{ fontSize: "15px" }}
                      component={
                        <Link
                          className="NavigationLink"
                          to="/customerLedger"
                          onClick={handleActive}
                        />
                      }
                    >
                      Customer Dues
                    </MenuItem>
                  )}
                </SubMenu>

                {userPermissions?.includes("view_stock_menu") && (
                  <SubMenu
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<InventoryRoundedIcon style={{ color: "inherit" }} />}
                    label="Stock"
                  >
                    {userPermissions?.includes("view_stock_menu") && (
                      <MenuItem
                        icon={<ShowChartIcon style={{ color: "inherit" }} />}
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        component={
                          <Link
                            className="NavigationLink"
                            to="/stock"
                            onClick={handleActive}
                          />
                        }
                      >
                        Stock Details
                      </MenuItem>
                    )}
                    {userPermissions?.includes("view_transfer_menu") && (
                      <MenuItem
                        icon={
                          <RetweetOutlined
                            style={{ color: "inherit", fontSize: "25px" }}
                          />
                        }
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        component={
                          <Link
                            className="NavigationLink"
                            to="/transferStock"
                            onClick={handleActive}
                          />
                        }
                      >
                        Transfer
                      </MenuItem>
                    )}
                    {userPermissions?.includes("view_damage_menu") && (
                      <MenuItem
                        icon={
                          <DeleteSweepRoundedIcon
                            style={{ color: "inherit", fontSize: "25px" }}
                          />
                        }
                        className="NavigationLink"
                        style={{ fontSize: "15px" }}
                        component={
                          <Link
                            className="NavigationLink"
                            to="/damageStock"
                            onClick={handleActive}
                          />
                        }
                      >
                        Damage Stock
                      </MenuItem>
                    )}
                  </SubMenu>
                )}
              </SubMenu>
            )}
            {userPermissions?.includes("view_sales_menu") && (
              <SubMenu
                className="NavigationLink "
                icon={<ShoppingCartIcon style={{ color: "inherit" }} />}
                style={{ fontSize: "15px" }}
                label={IS_SIDEBAR_OPEN ? "Sales" : null}
              >
                {userPermissions?.includes("view_sales_dashboard") && (
                  <MenuItem
                    icon={<GridViewIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/salesDashboard"
                        onClick={handleActive}
                      />
                    }
                  >
                    Dashboard
                  </MenuItem>
                )}
                {userPermissions?.includes("view_product_menu") && (
                  <MenuItem
                    icon={<ListAltIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/productList"
                        onClick={handleActive}
                      />
                    }
                  >
                    Product
                  </MenuItem>
                )}
                {userPermissions?.includes("view_sales_dashboard") && (
                  <MenuItem
                    icon={<ShoppingBasketIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/cashSales"
                        onClick={handleActive}
                      />
                    }
                  >
                    Sales Details
                  </MenuItem>
                )}
                {userPermissions?.includes("view_sales_target") && (
                  <MenuItem
                    icon={<TrackChangesIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/target"
                        onClick={handleActive}
                      />
                    }
                  >
                    Sales Target
                  </MenuItem>
                )}
                {userPermissions?.includes("view_product_price") && (
                  <MenuItem
                    icon={<ListIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/productPrice"
                        onClick={handleActive}
                      />
                    }
                  >
                    Order Price List
                  </MenuItem>
                )}
                {userPermissions?.includes("view_order_taking_menu") && (
                  <MenuItem
                    icon={<AddchartIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/orderTaking"
                        onClick={handleActive}
                      />
                    }
                  >
                    Order Taking
                  </MenuItem>
                )}
                {userPermissions?.includes("view_order_taking_menu") && (
                  <MenuItem
                    icon={<GradingIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/orderFulfillment"
                        onClick={handleActive}
                      />
                    }
                  >
                    Order Fulfillment
                  </MenuItem>
                )}
                {userPermissions?.includes("view_route_map_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<ForkRightIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/routeMap"
                        onClick={handleActive}
                      />
                    }
                  >
                    Route Map
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {userPermissions?.includes("view_sourcing_menu") && (
              <SubMenu
                className="NavigationLink "
                style={{ fontSize: "15px" }}
                icon={<LocalShippingIcon style={{ color: "inherit" }} />}
                label={IS_SIDEBAR_OPEN ? "Sourcing" : null}
              >
                {userPermissions?.includes("view_product_sourcing_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<GridViewIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/sourcingDashboard"
                        onClick={handleActive}
                      />
                    }
                  >
                    Dashboard
                  </MenuItem>
                )}
                {userPermissions?.includes("view_product_sourcing_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<LocalShippingIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/productSourcing"
                        onClick={handleActive}
                      />
                    }
                  >
                    Product Sourcing
                  </MenuItem>
                )}
                {userPermissions?.includes("view_price_app_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<PriceCheckIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/priceApp"
                        onClick={handleActive}
                      />
                    }
                  >
                    Price Analytics
                  </MenuItem>
                )}
                {userPermissions?.includes("view_sourcing_product_list") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<ListIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/sourcingList"
                        onClick={handleActive}
                      />
                    }
                  >
                    Sourcing Products
                  </MenuItem>
                )}

                {userPermissions?.includes("view_sourcing_menu") && (
                  <SubMenu
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<WarehouseIcon style={{ color: "inherit" }} />}
                    label="Warehouse"
                  >
                    {userPermissions?.includes("view_sourcing_menu") && (
                      <MenuItem
                        icon={<InputIcon style={{ color: "inherit" }} />}
                        style={{ fontSize: "15px" }}
                        className="NavigationLink"
                        component={
                          <Link
                            className="NavigationLink"
                            to="/warehouseStockIn"
                            onClick={handleActive}
                          />
                        }
                      >
                        Stock In
                      </MenuItem>
                    )}
                    {userPermissions?.includes("view_sourcing_menu") && (
                      <MenuItem
                        icon={<OutputIcon style={{ color: "inherit" }} />}
                        style={{ fontSize: "15px" }}
                        className="NavigationLink"
                        component={
                          <Link
                            className="NavigationLink"
                            to="/warehouseStockOut"
                            onClick={handleActive}
                          />
                        }
                      >
                        Stock Out
                      </MenuItem>
                    )}
                  </SubMenu>
                )}

                {userPermissions?.includes("view_industrial_partner_menu") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<FactoryIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/ipInfo"
                        onClick={handleActive}
                      />
                    }
                  >
                    Industrial Partner Info
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {userPermissions?.includes("view_employee_menu") && (
              <SubMenu
                className="NavigationLink "
                style={{ fontSize: "15px" }}
                icon={<EngineeringIcon style={{ color: "inherit" }} />}
                label={IS_SIDEBAR_OPEN ? "Employee" : null}
              >
                {userPermissions?.includes("view_create_user") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<PersonIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/user"
                        onClick={handleActive}
                      />
                    }
                  >
                    User
                  </MenuItem>
                )}
                {userPermissions?.includes("view_create_employee_profile") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    icon={<BadgeIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/employee"
                        onClick={handleActive}
                      />
                    }
                  >
                    Employee List
                  </MenuItem>
                )}
              </SubMenu>
            )}

            {userPermissions?.includes("view_database_menu") && (
              <SubMenu
                className="NavigationLink "
                style={{ fontSize: "15px" }}
                icon={<StorageIcon style={{ color: "inherit" }} />}
                label={IS_SIDEBAR_OPEN ? "Databases" : null}
              >
                {userPermissions?.includes("view_database_menu") && (
                  <MenuItem
                    icon={<GridViewIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databaseDashboard"
                        onClick={handleActive}
                      />
                    }
                  >
                    Dashboard
                  </MenuItem>
                )}
                {userPermissions?.includes("view_farmer_database") && (
                  <MenuItem
                    icon={<AgricultureIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databases/farmer"
                        onClick={handleActive}
                      />
                    }
                  >
                    Farmer
                  </MenuItem>
                )}
                {userPermissions?.includes("view_retailer_database") && (
                  <MenuItem
                    icon={
                      <StoreMallDirectoryIcon style={{ color: "inherit" }} />
                    }
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databases/retailer"
                        onClick={handleActive}
                      />
                    }
                  >
                    Retailer
                  </MenuItem>
                )}
                {userPermissions?.includes("view_asp_database") && (
                  <MenuItem
                    icon={
                      <PrecisionManufacturingIcon
                        style={{ color: "inherit" }}
                      />
                    }
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databases/asp"
                        onClick={handleActive}
                      />
                    }
                  >
                    ASP
                  </MenuItem>
                )}
                {userPermissions?.includes("view_lsp_database") && (
                  <MenuItem
                    icon={
                      <VolunteerActivismIcon style={{ color: "inherit" }} />
                    }
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databases/lsp"
                        onClick={handleActive}
                      />
                    }
                  >
                    LSP
                  </MenuItem>
                )}
                {userPermissions?.includes("view_trader_database") && (
                  <MenuItem
                    icon={<StorefrontIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databases/trader"
                        onClick={handleActive}
                      />
                    }
                  >
                    Trader
                  </MenuItem>
                )}
                {userPermissions?.includes("view_agro_processor_database") && (
                  <MenuItem
                    icon={<CoffeeMakerIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databases/institutionalBuyer"
                        onClick={handleActive}
                      />
                    }
                  >
                    Institutional Buyer
                  </MenuItem>
                )}

                {userPermissions?.includes(
                  "view_regular_customer_database",
                ) && (
                  <MenuItem
                    icon={<CoPresentIcon style={{ color: "inherit" }} />}
                    className="NavigationLink"
                    style={{ fontSize: "15px" }}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/databases/regularCustomer"
                        onClick={handleActive}
                      />
                    }
                  >
                    Regular Customer
                  </MenuItem>
                )}
              </SubMenu>
            )}

            {userPermissions?.includes("view_daily_report") && (
              <MenuItem
                className=" NavigationLink"
                style={{ fontSize: "15px" }}
                icon={<AssignmentTurnedInIcon style={{ color: "inherit" }} />}
                component={
                  <a
                    className="NavigationLink"
                    href={oneThreadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleActive}
                  >
                    {IS_SIDEBAR_OPEN ? "Agenda" : null}
                  </a>
                }
              >
                Agenda
              </MenuItem>
            )}
            {userPermissions?.includes("view_report_menu") && (
              <SubMenu
                className="NavigationLink "
                style={{ fontSize: "15px" }}
                icon={
                  <DocumentScannerOutlinedIcon style={{ color: "inherit" }} />
                }
                label={IS_SIDEBAR_OPEN ? "Reports" : null}
              >
                {userPermissions?.includes(
                  "view_sales_and_purchase_report",
                ) && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "13px" }}
                    icon={<ViewListOutlinedIcon style={{ color: "inherit" }} />}
                    component={
                      <Link
                        className="NavigationLink"
                        to="/salesReport"
                        onClick={handleActive}
                      />
                    }
                  >
                    Sales,Purchase & Dues
                  </MenuItem>
                )}
                {userPermissions?.includes("views_budget_expense_report") && (
                  <MenuItem
                    className="NavigationLink"
                    style={{ fontSize: "13px" }}
                    icon={
                      <PriceChangeOutlinedIcon style={{ color: "inherit" }} />
                    }
                    component={
                      <Link
                        className="NavigationLink"
                        to="/budgetReport"
                        onClick={handleActive}
                      />
                    }
                  >
                    Budget,Expense & Profit
                  </MenuItem>
                )}
              </SubMenu>
            )}
          </Menu>
        </Sidebar>
      </div>
    </>
  );
}
